<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
  >
    <path
      d="M11.9996 6.4998C12.3772 6.72637 12.3772 7.27364 11.9996 7.50021L2.05008 13.4699C1.66128 13.7032 1.16663 13.4231 1.16663 12.9697L1.16663 1.03028C1.16663 0.576857 1.66128 0.296791 2.05008 0.530075L11.9996 6.4998Z"
      fill="white"
    />
  </svg>
</template>
